import { render, staticRenderFns } from "./UssdHits.vue?vue&type=template&id=4f3d6ecd&scoped=true&"
import script from "./UssdHits.vue?vue&type=script&lang=ts&"
export * from "./UssdHits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d6ecd",
  null
  
)

export default component.exports